import DefaultCRUD from '../utils'
const resource = `/bridge`;

const { get, create } = DefaultCRUD(resource)

export default {
  get,
  create,
}
